import React, { Component } from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import { Button, Form, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import toastr from 'toastr';

import usersApi from '../../store/services/users';
import { connect } from 'react-redux';
import Blacklist from '../../store/services/blacklist';
import FormContainer from '../form-components/FormContainer';
import { ErrorMessages } from '../form-components/ErrorMessages';
import BlacklistForm from './BlacklistForm';

class NewBlacklistScreen extends Component {
  state = {
    loading: false,
    blacklist: {
      userId: undefined,
      firstName: '',
      lastName: '',
      emailAddress: '',
      customer: '',
    },
    error: {},
    userError: false,
    hasUserId: false,
    user: {},
  };

  _mutate = cb => {
    this.setState(produce(cb));
  };

  _handleTextChanged = (event, { name, value }) => {
    this._mutate(draft => {
      draft.blacklist[name] = value;
    });
  };

  _blacklist = async emailAddress => {
    let user = await usersApi.fetchByEmail(emailAddress);

    withLifecycles(
      () =>
        Blacklist.blacklist({
          ...user.result,
          userId: user.result.id,
          customer: user.result.company || user.result.customerName,
        }),
      ({ loading, data, error }) => {
        this.setState(
          produce(draft => {
            draft.saving = loading;
            draft.error = error;

            if (data && !data.hasErrors) {
              this._loadBlacklists(0, '');
              this.props.history.push('/manage/blacklists');
              toastr.success('User Blacklisted');
            }
          })
        );
      }
    );
  };

  _loadBlacklists = (pageNumber, searchTerm) => {
    withLifecycles(
      () =>
        Blacklist.fetch({
          request: {
            page: pageNumber,
            pageSize: 20,
          },
          searchTerm: searchTerm,
          orderByName: false,
        }),
      ({ loading, data }) => {
        this.setState({ activePage: pageNumber + 1 });
        this.setState(
          produce(draft => {
            draft.loading = loading;

            if (data && !data.hasErrors) {
              draft.pageInfo = data.result;
            }
          })
        );
      }
    );
  };

  _save = () => {
    withLifecycles(
      () => Blacklist.blacklist(this.state.blacklist),
      ({ loading, data, error }) => {
        this._mutate(draft => {
          draft.loading = loading;
          draft.error = error;
          this.userError = false;
          let errorLength = (draft.error.errors || []).length;
          let errorMessages = (draft.error.errors || []).map(
            x => x.errorMessage
          );

          if (data && !data.hasErrors) {
            this._loadBlacklists(0, '');
            toastr.success('Blacklist Created');
            this.props.history.push('/manage/blacklists');
          } else if (
            errorLength === 1 &&
            errorMessages[0] ===
            'A user with this email address already exists.'
          ) {
            this.userError = true;
          }
        });
      }
    );
  };

  render() {
    const { error, loading, blacklist } = this.state;

    return (
      <FormContainer loading={loading}>
        <Form onSubmit={this._save}>
          <BlacklistForm
            blacklist={blacklist}
            handleTextChanged={this._handleTextChanged}
            isReadOnly={false}
            isBeingEdited={false}
          />
          <ErrorMessages error={error} />
          <Button type="submit">
            <Icon
              style={{ paddingRight: '15px' }}
              name="eye slash"
              color="Black"
            />
            Blacklist
          </Button>
          {this.userError === true && (
            <Button
              type="button"
              color="red"
              content="Would you like to blacklist this user?"
              onClick={() => this._blacklist(blacklist.emailAddress)}
            >
              Blacklist this user
            </Button>
          )}
          <Button basic as={Link} to="/manage/blacklists">
            Cancel
          </Button>
        </Form>
      </FormContainer>
    );
  }
}

const mapStateToProps = ({ customers, identity }) => ({
  customers: customers.data,
  role: identity.user.role,
});

export default connect(mapStateToProps)(NewBlacklistScreen);
